import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {throwError} from 'rxjs';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AppError} from '../commons/app-error';
import {NotFoundError} from '../commons/not-found-error';

@Injectable()
export class BasicDataService {

    public static handleError(error: any) {
        if ( error.status === 400 ) {
            return throwError(() => new AppError(error));
        } else if ( error.status === 404 ) {
            return throwError(() => new NotFoundError(error));
        } else {
            return throwError(() => error);
        }
    }

    constructor(private httpClient: HttpClient) {}

    getAll(url: string): Observable<any> | any{
        return this.httpClient.get(url).pipe(catchError(BasicDataService.handleError));
    }

    create(url: string, resource: any): Observable<any> | any{
        return this.httpClient.post(url, JSON.stringify(resource)).pipe(catchError(BasicDataService.handleError));
    }

    update(url: string, resource: any): Observable<any> | any {
        return this.httpClient.put(url, JSON.stringify(resource)).pipe(catchError(BasicDataService.handleError));
    }

    delete(url: string): Observable<any> | any {
        return this.httpClient.delete(url).pipe(catchError(BasicDataService.handleError));
    }

}
